import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'providerStatusText',
})
export class ProviderStatusTextPipe implements PipeTransform {
  transform(isActive: boolean, isHovered: boolean): string {
    if (isHovered) {
      return isActive ? 'Deactivate' : 'Activate';
    } else {
      return isActive ? 'Active' : 'Inactive';
    }
  }
}
